<template>
  <div class="row">
    <div class="col-md-12">
      <!-- Modal -->
      <div class="modal fade" id="seeAsks" role="dialog">
        <div
          class="modal-dialog modal-dialog-centered modal-lg"
          role="document"
        >
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">Perguntas</h5>
              <button type="button" class="close" data-dismiss="modal">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div v-for="ask in asksInModal" :key="ask.id">
                <p>
                  <strong>{{ ask.title }}</strong>
                  <span class="badge badge-primary" v-if="ask.type_id == 1"
                    >Escala</span
                  >
                  <span class="badge badge-success" v-if="ask.type_id == 2"
                    >Alternativa</span
                  >
                  <span class="badge badge-warning" v-if="ask.type_id == 3"
                    >Dissertativa</span
                  >
                  <span class="badge badge-secondary" v-if="ask.type_id == 3"
                    >IA</span
                  >
                  <span class="badge badge-info" v-if="ask.type_id == 4"
                    >Ranking</span
                  >
                </p>
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-secondary"
                data-dismiss="modal"
              >
                Fechar
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <div class="card-title">Grafico de Dimensões</div>
        </div>
        <div
          class="row"
          v-for="(dimensions, dimension) in research.dimensions"
          :key="dimensions.id"
        >
          <div class="col-md-12">
            <br />
            <div class="card">
              <div class="card-header">
                <div class="d-flex justify-content-between my-1">
                  <div class="card-title card-center">{{ dimensions }}</div>
                  <!-- <button class="btn btn-normal-slim" @click="seeAsks(dimension)">Ver Perguntas</button> -->
                </div>
              </div>
              <div
                class="charts"
                v-for="(charts, chart_dimension) in research.charts"
                :key="chart_dimension"
              >
                <div
                  class="charts-by-dimension"
                  v-if="chart_dimension === dimension"
                >
                  <div class="container-fluid">
                    <div class="row p-2">
                      <div
                        class="col p-1 m-1 shadow rounded scale-charts"
                        v-if="charts.scale"
                        :key="'department-' + chart_dimension"
                      >
                        <h5>Visão Departamento</h5>
                        <span class="font-italic"
                          >Valores exibidos em <strong>quantidade</strong></span
                        >
                        <horizontal-bar
                          :chart-data="charts.scale.department"
                          :options="chartOptions"
                        />
                      </div>
                      <div
                        class="col p-1 m-1 shadow rounded scale-charts"
                        v-if="charts.scale"
                        :key="'company-' + chart_dimension"
                      >
                        <h5>Visão Empresa</h5>
                        <span class="font-italic"
                          >Valores exibidos em <strong>quantidade</strong></span
                        >
                        <horizontal-bar
                          :chart-data="charts.scale.company"
                          :options="chartOptions"
                        />
                      </div>
                    </div>

                    <div class="row p-2">
                      <div
                        class="col p-1 m-1 shadow rounded"
                        v-if="charts.alternatives"
                        :key="'alternatives-' + chart_dimension"
                      >
                        <div class="p-5" v-if="charts.alternatives">
                          <h5>Alternativas</h5>
                          <span class="font-italic"
                            >Valores exibidos em
                            <strong>quantidade</strong></span
                          >
                          <bar-chart
                            :chart-data="charts.alternatives"
                            :options="chartOptions"
                          />
                        </div>
                      </div>
                      <div
                        class="col p-1 m-1 shadow rounded"
                        v-if="charts.essays && research.select_essay == 1"
                        :key="'essays-' + chart_dimension"
                      >
                        <div class="essay-charts" v-if="charts.essays">
                          <h5>Dissertativas</h5>
                          <span class="font-italic"
                            >Valores exibidos em
                            <strong>porcentagem</strong></span
                          >
                          <bar-chart
                            :chart-data="charts.essays"
                            :options="essayOptions"
                          />
                        </div>
                        <hr />
                        <div class="alert alert-light shadow" role="alert">
                          <h5 class="alert-heading pb-2">Perguntas</h5>
                          <hr />
                          <div v-for="ask in research.asks" :key="ask.id">
                            <p
                              v-if="
                                ask.dimension_id == dimension &&
                                ask.type_id == 3
                              "
                            >
                              <strong>Pergunta n° {{ ask.id }}:</strong>
                              {{ ask.title }}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div
                        class="col p-1 m-1 shadow rounded"
                        v-if="charts.ranking"
                        :key="'ranking-' + chart_dimension"
                      >
                        <div class="p-2" v-if="charts.ranking">
                          <h5>Ranking</h5>
                          <span class="font-italic"
                            >Valores exibidos em
                            <strong>quantidade</strong></span
                          >
                          <horizontal-bar
                            :chart-data="charts.ranking"
                            :options="chartOptions"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HorizontalBar from "../Charts/HorizontalBar.js";
import BarChart from "../Charts/Bar.js";

export default {
  data() {
    return {
      asksInModal: [],
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          datalabels: {
            backgroundColor: "rgba(0, 0, 0, .2",
            color: "white",
            borderRadius: 2,
            align: "center",
            anchor: "center",
            clamp: true,
          },
        },
        scales: {
          xAxes: [
            {
              stacked: true,
              ticks: {
                fontFamily: "'Open Sans Bold', sans-serif",
                fontSize: 11,
                beginAtZero: true,
              },
            },
          ],
          yAxes: [
            {
              stacked: true,
              ticks: {
                beginAtZero: true,
              },
            },
          ],
        },
      },
      essayOptions: {
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
          enabled: true,
          callbacks: {
            label: function (tooltipItem, data) {
              var allData = data.datasets[tooltipItem.datasetIndex].data;
              var tooltipData = allData[tooltipItem.index];
              return tooltipData + "%";
            },
          },
        },
        plugins: {
          datalabels: {
            backgroundColor: "rgba(0, 0, 0, .2",
            color: "white",
            borderRadius: 2,
            formatter: function (value, context) {
              return value + "%";
            },
          },
        },
        scales: {
          xAxes: {
            min: 1,
            stacked: true,
            ticks: {
              fontFamily: "'Open Sans Bold', sans-serif",
              fontSize: 11,
            },
          },
          yAxes: {
            min: 1,
            stacked: true,
            ticks: {
              beginAtZero: true,
            },
          },
        },
      },
    };
  },
  methods: {
    seeAsks(dimension_id) {
      const asks = this.research.asks;
      this.asksInModal = [];

      asks.forEach((element) => {
        if (element.dimension_id == dimension_id) {
          this.asksInModal.push(element);
        }
      });
      $("#seeAsks").modal("show");
    },
  },
  components: {
    HorizontalBar,
    BarChart,
  },
  props: ["research"],
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/Reusable/DimensionCharts.vue